import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { OOMenu } from "src/app/shared/models/oo-menu";

@Component({
	selector: "app-custom-menu-record",
	templateUrl: "./custom-menu-record.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomMenuRecordComponent implements OnInit, OnDestroy {
	@Input() customMenuSelected: OOMenu;
	@Output() customMenuSelectedChange = new EventEmitter<OOMenu>();

	assignableCanvases: OOCanvas[];
	assignedCanvases: OOCanvas[];

	ooCanvasSubscription: Subscription = new Subscription();

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService) {}
	ngOnDestroy(): void {
		this.ooCanvasSubscription.unsubscribe();
	}

	ngOnInit(): void {
		if (!this.customMenuSelected.externalLinks) {
			this.customMenuSelected.externalLinks = [];
		}
		this.customMenuAssign(this.customMenuSelected);
	}

	async customMenuAssign(rec: OOMenu) {
		this.assignableCanvases = this.venueService.subscriptionOOcanvas.value.filter((i) => i.online);
		this.assignedCanvases = this.assignableCanvases.filter((i) => {
			if (i.menuIds) {
				return i.menuIds.some((n) => n === rec.key);
			}
		});

		this.customMenuSelected = rec;
	}

	async customMenuAssignSave() {
		this.venueService.menuSave(this.customMenuSelected);
		const customMenuKey = this.customMenuSelected.key;
		const customMenuName = this.customMenuSelected.name;
		this.customMenuSelected = undefined;
		const modifiedCanvses: OOCanvas[] = [];

		//handle canvases that have been unassigned
		this.assignableCanvases.forEach((i) => {
			const present = this.assignedCanvases.some((n) => n.canvasKey === i.canvasKey);
			//if false, canvas is not assigned
			if (!present) {
				if (i.menuIds?.includes(customMenuKey)) {
					const idx = i.menuIds.findIndex((n) => n === customMenuKey);
					i.menuIds.splice(idx, 1);
					modifiedCanvses.push(i);
				}
			}
		});

		this.assignedCanvases.forEach((canvas) => {
			const modifiedCanvasRecord = modifiedCanvses.find((i) => i.canvasKey === canvas.canvasKey);
			if (modifiedCanvasRecord) {
				modifiedCanvasRecord.menuIds.push(customMenuKey);
			} else {
				const assignedCan = this.venueService.subscriptionOOcanvas.value.find((i) => i.canvasKey === canvas.canvasKey);
				if (!assignedCan.menuIds) {
					assignedCan.menuIds = [];
				}
				assignedCan.menuIds.push(customMenuKey);
				modifiedCanvses.push(assignedCan);
			}
		});

		modifiedCanvses.forEach((i) => {
			if (!i.menuIds.includes("0")) {
				i.menuIds.push("0");
			}
		});
		await this.focuslink.canvasPost(this.venueService.subscriptionVenue.value.key, modifiedCanvses);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `${customMenuName} saved.` });
	}

	async customMenuSave(rec: OOMenu | OOMenu[]) {
		await this.focuslink.menuPost(this.venueService.subscriptionVenue.value.key, rec);
	}

	customMenuDelete(recKey: string) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete this menu?`,
			accept: async () => {
				console.log("accepted");
				this.customMenuSelected = undefined;

				await this.venueService.menuDelete(this.venueService.subscriptionOOmenu.value.find((i) => i.key === recKey));
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
